export default {
    getBookingForm: (state) => {
        return state.bookingForm
    },
    getBooking: (state) => {
        return state.booking
    },
    getBookingChangelog: (state) => {
        return state.bookingChangelog
    },
    getIsReturnBooking: (state) => {
        return state.isReturnBooking
    },
    getIncludeUnconfirmedBookings: (state) => {
        return state.includeUnconfirmedBookings
    },
    getBookingTypesFilter: (state) => {
        return state.bookingTypesFilter
    },
    getCustomerIdFilter: (state) => {
        return state.customerIdFilter
    }
}
